import type React from 'react';

import IconLoading from '@assets/images/gif/loading.gif';

import { HEADER_STRINGS } from '../../utils/header.constants';

import { useUserContactLogic } from './user-contact.hook';
import * as S from './user-contact.styles';

const LoadingImg = () => (
	<img alt={HEADER_STRINGS.LOADING_PHONE_ALT} src={IconLoading} />
);

const UserContact = () => {
	const {
		email,
		phone,
		isPhoneLoading,
		showPhone,
		emailHref,
		phoneLinkProps,
		phoneLoading,
		phoneError,
		phoneTitle,
		showPhoneClickHandler,
		showPhoneLabel,
	} = useUserContactLogic();

	return (
		<S.ContactWrapper>
			<S.Email
				{...{ as: 'a' as React.ElementType, href: emailHref }}
				data-qa="user-email-link"
				title={HEADER_STRINGS.EMAIL_TITLE}
			>
				{email}
			</S.Email>
			{showPhone ? (
				<S.Phone
					loading={phoneLoading}
					error={phoneError}
					{...phoneLinkProps}
					title={phoneTitle}
				>
					{isPhoneLoading ? <LoadingImg /> : phone}
				</S.Phone>
			) : (
				<S.ShowPhone
					data-qa="show-phone-button"
					onClick={showPhoneClickHandler}
					type="button"
				>
					{showPhoneLabel ? HEADER_STRINGS.SEE_PHONE : <LoadingImg />}
				</S.ShowPhone>
			)}
		</S.ContactWrapper>
	);
};

UserContact.displayName = 'UserContact';
export { UserContact };
